import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// The custom type scale in tailwind.config.ts (text-meta, text-emphasis, …) must be
// known as font sizes, or tailwind-merge treats them as colours and drops them
// when a text colour follows (e.g. "text-emphasis text-ink" -> "text-ink").
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [{ text: ["eyebrow", "meta", "body", "emphasis", "title", "page", "metric", "metric-lg"] }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
